// removed by extract-text-webpack-plugin
module.exports = {"orderList":"orders-navigation__orderList-2hMC9","head":"orders-navigation__head-1G6Ku","controls":"orders-navigation__controls-1k1QV","radio":"orders-navigation__radio-1EgMT","clearFiltersButton":"orders-navigation__clearFiltersButton-O5NUE blocks__grey-2yo9d blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders-navigation/orders-navigation.css
// module id = 774
// module chunks = 0